<script type="ts">
    import AktuellesButton from "../components/AktuellesButton.svelte";
    import { url, urlRoute, isChangingPage } from "@roxi/routify";
    import Footer from "../components/Footer.svelte";
    import Nav from "../components/Nav.svelte";
    import PageLoader from "../components/PageLoader.svelte";
    import Cookies from "js-cookie";
    import { onMount } from "svelte";
    import Stoerer from "../components/Stoerer.svelte";
    import Btn from "../components/Btn.svelte";
    import { t } from "../helpers/translation";
    import FloatingContact from "../components/FloatingContact.svelte";
</script>

<Nav />

<main>
    <slot />
</main>

<!-- prettier-ignore -->
<!-- <Stoerer
    confirmedCookieName="fahrzeugtechnikClicked2"
    heading="Achtung"
    subline="Sonder–und Fahrzeugtechnik Hausmesse 2024"
    fontSize="clamp(1rem, 3vw, 1.25rem)"
    startDate={new Date("2024-02-09")}
    endDate={new Date("2024-03-09")}
>
    <p class="allow-newline">
        mit Firma C.B. König
    </p>
    <p class="allow-newline">
        Freitag, 08.03., 12 - 18 Uhr 
        Samstag, 09.03., 9 - 13 Uhr
    </p>
    <p>
        Weitere Informationen und eine unverbindliche Anmeldung finden Sie 
        <a target="_blank" href="https://reglist24.com/sinus-hausmesse-2024">
            hier
        </a>
    </p>
</Stoerer> -->
<!-- prettier-ignore -->
<!-- <Stoerer
    confirmedCookieName="kamen-new-address"
    heading="Achtung"
    subline="Standort Kamen zieht um!"
    fontSize="clamp(1rem, 3vw, 1.25rem)"
    startDate={new Date("2024-04-15")}
    endDate={new Date("2024-07-01")}
    width="17em"
    height="17em"
    padding="2.5em"
>
    <p class="allow-newline">
        Unser Standort Kamen hat ab dem <strong>1. Mai</strong> eine neue Adresse:
    </p>
    <p class="allow-newline">
        Kamener Straße 110, 
        59425 Unna.
    </p>
</Stoerer> -->
<!-- <Stoerer
    confirmedCookieName="pforzheim-new-address"
    heading="Achtung"
    subline="Standort Pforzheim zieht um!"
    fontSize="clamp(1rem, 3vw, 1.25rem)"
    startDate={new Date("2024-08-1")}
    endDate={new Date("2024-09-15")}
    width="17em"
    height="17em"
    padding="2.5em"
>
    <p class="allow-newline">
        Unser Standort Pforzheim hat ab dem <strong>1. August</strong> eine neue
        Adresse:
    </p>
    <p class="allow-newline">Welschenäckerstraße 10 75177 Pforzheim</p>
</Stoerer> -->

<Stoerer
    confirmedCookieName="gruenderpreis-2024"
    heading=""
    subline={$t("special.stoerer.subline")}
    fontSize="clamp(1rem, 2vw, 1.25rem)"
    startDate={new Date("2024-09-10")}
    endDate={new Date("2024-10-10")}
    width="17em"
    height="17em"
    padding="2.5em"
    href="/s/aktuelles/news/62/hamburger-gründerpreis-2024-in-der-kategorie-aufsteiger-geht-an-sinus-nachrichtentechnik-gmbh"
    hrefText={$t("special.stoerer.btn.readmore")}
>
    <img
        src="/img/gruenderpreis-2024.jpg"
        alt="Hamburger Gründerpreis 2024"
        style="
            width: 100%; 
            max-width: 8rem; 
            max-height: 4.5rem; 
            object-fit: contain;
            object-position: center;
            display: block; 
            margin: auto;
            margin-bottom: .5em;
        "
    />
    <p>
        {@html $t("special.stoerer.p")}
    </p>
</Stoerer>

<PageLoader />

<Footer />

<FloatingContact />

<!-- globals -->
<!-- globals -->
<!-- globals -->
<svelte:head>
    <title>Sinus Nachrichtentechnik</title>
    <style lang="scss">
        @import "../main";
    </style>
</svelte:head>
